/**
 * @fileoverview ストレージユーティリティ util
 */
'use strict';
// Library Import
import _ from 'lodash';
// Util Import
import * as ConstUtil from './ConstUtil';

/**
 * 設定情報更新
 *
 * @param {String} conponentName 画面名
 * @param {String} itemName 項目名
 * @param {any} value 値
 */
export const updateSettingMemory = (conponentName, itemName, value) => {
  if (_.isUndefined(value)) {
    return;
  }
  // 設定記憶情報が空の場合
  if (
    _.isEmpty(localStorage.getItem(ConstUtil.Common.STORAGE_KEY.SETTING_MEMORY))
  ) {
    // 初期値をセット
    localStorage.setItem(
      ConstUtil.Common.STORAGE_KEY.SETTING_MEMORY,
      JSON.stringify(ConstUtil.Common.SETTING_MEMORY_DEFAULT)
    );
  }
  let settingMemory = JSON.parse(
    localStorage.getItem(ConstUtil.Common.STORAGE_KEY.SETTING_MEMORY)
  );
  // 更新
  settingMemory[conponentName][itemName] = value;
  localStorage.setItem(
    ConstUtil.Common.STORAGE_KEY.SETTING_MEMORY,
    JSON.stringify(settingMemory)
  );
};

/**
 * 設定情報更新
 *
 * @param {String} componentName 画面名
 * @param {*} settingMemories 項目名:値
 */
export const updateSettingMemories = (componentName, settingMemories) => {
  _.each(settingMemories, (value, itemName) =>
    updateSettingMemory(componentName, itemName, value)
  );
};

/**
 * 設定記憶情報取得
 *
 * @param {String} conponentName 画面名
 * @param {String} itemName 項目名
 * @returns {String} 設定記憶情報
 */
export const getSettingMemory = (conponentName, itemName) => {
  let settingMemory = JSON.parse(
    localStorage.getItem(ConstUtil.Common.STORAGE_KEY.SETTING_MEMORY)
  );
  if (_.isEmpty(settingMemory) || _.isEmpty(settingMemory[conponentName])) {
    return '';
  }
  return settingMemory[conponentName][itemName];
};



// WEBPACK FOOTER //
// ./src/js/util/StorageUtil.jsx